import { RootState } from 'src/types';

export const multipleQuotesSelector = (state: RootState) =>
    state.multipleQuotes.multipleQuotes;
